import React from 'react';
import styled from 'react-emotion';
import ActivityGroupList from '../ActivityGroupList';
import ClearButton from './ClearButtonContainer';

const Filters = styled.div`
  height: 40px;
  background-color: #fff;
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  margin-left: 22px;
  font-size: 18px;
  font-weight: 21px;
  text-transform: uppercase;
`;

const ActivityGroupFilter = () => (
  <Filters>
    <Title>Filtrer par</Title>
    <ActivityGroupList margin="10px" />
    <ClearButton />
  </Filters>
);

export default ActivityGroupFilter;



// WEBPACK FOOTER //
// ./src/components/ActivityGroupFilter/ActivityGroupFilter.jsx